import React, { Component } from 'react';

import {Link} from "react-router-dom";

import "../index.css";
import Logo from "../assets/logo.png";

import {Footer as StFooter} from "../repo/footer/standard/standard";

class Footer extends Component {
    
    render() { 

        const FontColor = (this.props.darkTheme) ? "white" : "black";


        const importantLinks = {
            0: [
                <Link key={0} style={{color:FontColor }} className={(window.location.pathname === "/") ? "footer_selected" : "footer_unselected"} to="/">Home</Link>,
            ],
        };

        const importantLinksColumnHead = [
            "Navigate",
        ];

        const description = "Re:anime has been taken down, please uninstall the app. ";
        
        const copyright = ""

        const SvgFollowUs = {}

        return (
            <StFooter 
                importantLinks={importantLinks}
                importantLinksColumnHead={importantLinksColumnHead}
                logo={<img id="MyersFooter_Standard_logo" style={{maxWidth: "200px"}} src={Logo} alt="Company Logo"/>}
                SvgFollowUs={SvgFollowUs}
                description={description}
                copyright={copyright}
                primaryColorDark="red"
                backgroundColorDark="#1b1b1b"
                borderColorDark="white"
                primaryFontColorDark="white"
                secondaryFontColorDark="white"
                primaryColor="red"
                backgroundColor="white"
                borderColor="lightgray"
                primaryFontColor="black"
                secondaryFontColor="white"
                theme={(!this.props.darkTheme)}
            />
        );
    }
}
 
export default Footer;